var isPerksGORetailDeal = function (deal) {
    return !!(deal === null || deal === void 0 ? void 0 : deal.isPerksGoRetailDeal);
};
export default isPerksGORetailDeal;
